import types from '../../../mutation-types';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType
) => {
  const { payload: conversationList, meta: metaData } = responseData;
  const page = Number(requestPayload.page || 1);
  // Mesmo default do ConversationFinder (CONVERSATION_RESULTS_PER_PAGE).
  const resultsPerPage = 25;

  // Página 1 substitui a lista (evita manter conversas de outra aba, ex. grupos em "Todos").
  // Reconnect (updatedWithin): merge incremental — não apagar histórico já hidratado.
  const isReconnectSync =
    requestPayload.updatedWithin != null && requestPayload.updatedWithin !== '';
  context.commit(types.SET_ALL_CONVERSATION, {
    conversationList,
    replace: page === 1 && !isReconnectSync,
  });

  // Badge = total real da aba quando a 1ª página já veio incompleta (não há página 2).
  // Cobre me / unassigned / all — evita contador > itens da lista por exceções de filtro.
  const tabCountKey = {
    me: 'mine_count',
    unassigned: 'unassigned_count',
    all: 'all_count',
  }[filterType];

  let tabMeta = metaData;
  if (tabCountKey && page === 1 && metaData) {
    const payloadSize = Array.isArray(conversationList)
      ? conversationList.length
      : 0;
    if (payloadSize < resultsPerPage) {
      tabMeta = { ...metaData, [tabCountKey]: payloadSize };
    }
  }

  context.dispatch('conversationStats/set', tabMeta);
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: !conversationList.length,
  });
};
